import React from 'react';

interface CredentialsColumnProps {
  info: {
    OfficeName: string;
    Address1: string;
    Postal: string;
    City: string;
    CountryName: string;
    PhoneNumber?: string;
  };
  allOfficesButton: string;
  corporateContactUsPageLink: string;
}

export const CredentialsColumn = ({
  info,
  allOfficesButton,
  corporateContactUsPageLink,
}: CredentialsColumnProps) => {
  const phoneNum = info.PhoneNumber ? info.PhoneNumber.split(',') : null;
  const phoneNumField = phoneNum
    ? phoneNum.map((PhoneNumber, index) => {
        return (
          <p key={index}>
            <a href={'tel:' + PhoneNumber}>{PhoneNumber}</a>
          </p>
        );
      })
    : '';

  return (
    <div key='credentials' className='l-footer-content-column l-footer-address'>
      <svg xmlns='http://www.w3.org/2000/svg' className='left-arc'>
        <path
          d='M 0 20
 A 20 20, 0, 0, 0, 20 0
 L 20 20 Z'
          fill='#11387F'
        ></path>
      </svg>
      <div>
        {info && (
          <section className='c-info-column-contact'>
            <p>{info.OfficeName}</p>
            <p>{info.Address1}</p>
            <p>
              {info.Postal} {info.City}
            </p>
            <p>{info.CountryName}</p>
            {phoneNumField[0]}
          </section>
        )}
        <a
          href={
            corporateContactUsPageLink +
            '?countryId=' +
            window.countryId +
            '&officeTypeId=0&zipcode=null&isFilter=true&toScroll=false'
          }
          className='c-button is-cta is-medium'
        >
          {allOfficesButton}
        </a>
      </div>
    </div>
  );
};
